export const ECONOMIC_EVENTS = [
  {
    name: "RBI MPC Meeting",
    country: "IN",
    dates: ["2026-04-08", "2026-06-04", "2026-08-06", "2026-10-08", "2026-12-03"],
    impact: "High",
    description: "Reserve Bank of India sets repo rate and monetary policy stance."
  },
  {
    name: "Fed FOMC Decision",
    country: "US",
    dates: ["2026-05-06", "2026-06-17", "2026-07-29", "2026-09-16", "2026-11-04", "2026-12-16"],
    impact: "High",
    description: "Federal Reserve sets US interest rates and monetary policy."
  },
  {
    name: "US Non-Farm Payrolls",
    country: "US",
    dates: ["2026-04-03", "2026-05-01", "2026-06-05", "2026-07-02", "2026-08-07", "2026-09-04", "2026-10-02", "2026-11-06", "2026-12-04"],
    impact: "High",
    description: "Monthly US jobs report. Major market mover."
  },
  {
    name: "US CPI Inflation",
    country: "US",
    dates: ["2026-04-14", "2026-05-13", "2026-06-10", "2026-07-14", "2026-08-12", "2026-09-11"],
    impact: "High",
    description: "Consumer Price Index measures US inflation."
  },
  {
    name: "India GDP",
    country: "IN",
    dates: ["2026-05-29", "2026-08-28", "2026-11-28"],
    impact: "High",
    description: "India quarterly GDP growth rate."
  },
  {
    name: "India CPI",
    country: "IN",
    dates: ["2026-04-14", "2026-05-12", "2026-06-12", "2026-07-14"],
    impact: "Medium",
    description: "India Consumer Price Index inflation data."
  },
  {
    name: "US GDP (Advance)",
    country: "US",
    dates: ["2026-04-29", "2026-07-29", "2026-10-28"],
    impact: "High",
    description: "First estimate of US quarterly GDP growth. Significant market mover."
  },
  {
    name: "ECB Interest Rate Decision",
    country: "EU",
    dates: ["2026-04-16", "2026-06-11", "2026-07-23", "2026-09-10", "2026-10-29", "2026-12-17"],
    impact: "High",
    description: "European Central Bank sets eurozone interest rates. Impacts global markets."
  },
  {
    name: "BOJ Policy Meeting",
    country: "JP",
    dates: ["2026-04-28", "2026-06-16", "2026-07-31", "2026-09-18", "2026-10-30", "2026-12-18"],
    impact: "Medium",
    description: "Bank of Japan monetary policy decision. Affects yen and Asian markets."
  },
  {
    name: "India PMI Manufacturing",
    country: "IN",
    dates: ["2026-04-01", "2026-05-04", "2026-06-01", "2026-07-01", "2026-08-03", "2026-09-01", "2026-10-01", "2026-11-02", "2026-12-01"],
    impact: "Medium",
    description: "Purchasing Managers Index for Indian manufacturing sector. Above 50 = expansion."
  },
  {
    name: "US ISM Manufacturing PMI",
    country: "US",
    dates: ["2026-04-01", "2026-05-01", "2026-06-01", "2026-07-01", "2026-08-03", "2026-09-01", "2026-10-01", "2026-11-02", "2026-12-01"],
    impact: "Medium",
    description: "ISM Manufacturing index. Above 50 indicates expansion, below 50 contraction."
  },
  {
    name: "US Retail Sales",
    country: "US",
    dates: ["2026-04-15", "2026-05-15", "2026-06-16", "2026-07-16", "2026-08-14", "2026-09-16"],
    impact: "Medium",
    description: "Monthly change in US retail sales. Key indicator of consumer spending."
  },
  {
    name: "India WPI Inflation",
    country: "IN",
    dates: ["2026-04-14", "2026-05-14", "2026-06-14", "2026-07-14", "2026-08-14", "2026-09-14"],
    impact: "Medium",
    description: "Wholesale Price Index measures wholesale-level inflation in India."
  },
  {
    name: "India Industrial Production (IIP)",
    country: "IN",
    dates: ["2026-04-11", "2026-05-12", "2026-06-12", "2026-07-11", "2026-08-12", "2026-09-11"],
    impact: "Medium",
    description: "Index of Industrial Production measures output of India's industrial sector."
  },
  {
    name: "US Unemployment Claims",
    country: "US",
    dates: ["2026-04-02", "2026-04-09", "2026-04-16", "2026-04-23", "2026-04-30", "2026-05-07", "2026-05-14", "2026-05-21", "2026-05-28", "2026-06-04", "2026-06-11", "2026-06-18"],
    impact: "Medium",
    description: "Weekly initial jobless claims. Rising claims signal weakening labor market."
  },
  {
    name: "India RBI Credit Policy Minutes",
    country: "IN",
    dates: ["2026-04-22", "2026-06-18", "2026-08-20", "2026-10-22", "2026-12-17"],
    impact: "Medium",
    description: "Detailed minutes of RBI MPC discussions. Reveals policy direction and member voting patterns."
  },
  {
    name: "US Fed Meeting Minutes",
    country: "US",
    dates: ["2026-04-08", "2026-05-27", "2026-07-08", "2026-08-19", "2026-10-07", "2026-11-25"],
    impact: "Medium",
    description: "Detailed record of FOMC deliberations. Provides insight into future rate decisions."
  },
  {
    name: "India Trade Balance",
    country: "IN",
    dates: ["2026-04-15", "2026-05-15", "2026-06-15", "2026-07-15", "2026-08-14", "2026-09-15"],
    impact: "Medium",
    description: "Difference between exports and imports. Trade deficit impacts rupee and forex reserves."
  },
];
